export let WEEKDAYS = /*#__PURE__*/function (WEEKDAYS) {
  WEEKDAYS["sunday"] = "sunday";
  WEEKDAYS["monday"] = "monday";
  WEEKDAYS["tuesday"] = "tuesday";
  WEEKDAYS["wednesday"] = "wednesday";
  WEEKDAYS["thursday"] = "thursday";
  WEEKDAYS["friday"] = "friday";
  WEEKDAYS["saturday"] = "saturday";
  return WEEKDAYS;
}({});
export const isInWorkingTime = (date, businessHours) => {
  if (businessHours.openTwentyFourSeven) {
    return true;
  }
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const weekDay = Object.values(WEEKDAYS)[date.getUTCDay()];
  return businessHours[weekDay].some(_ref => {
    let {
      enabled,
      start,
      end
    } = _ref;
    const isBefore = start && (start.hours > hours || start.hours === hours && minutes < start.minutes);
    const isAfter = end && (end.hours < hours || end.hours === hours && minutes > end.minutes);
    return enabled && !isBefore && !isAfter;
  });
};
//# sourceMappingURL=businessHours.js.map